export const PageLoader = () => (
  <div
    className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#1E2235]/80 backdrop-blur-sm"
    aria-live="polite"
    aria-label="Signing in, please wait…"
  >
    <div className="w-12 h-12 rounded-full border-4 border-white/20 border-t-brand-pink animate-spin mb-4" />
    <p className="text-white text-[0.9375rem] font-medium opacity-90">Signing in…</p>
  </div>
);
